import { pubSub } from '@utils/PubSub';
import { useSwym } from '@utils/Swym';

export class SwymResults extends HTMLElement {
  constructor() {
    super();

    this.dom = {
      json: this.querySelector('.product-grid-json'),
      grid: this.querySelector('.js-product-grid'),
      banner: this.querySelector('.WishlistResultsBanner'),
    };

    this.state = {
      items: [],
      isInitialized: false,
    };

    this.handleServiceUpdate = this.updateResults.bind(this);
  }

  get listContents() {
    return useSwym.listContents;
  }

  updateResults() {
    if (!this.state.isInitialized) {
      pubSub.unsubscribe('swym:service:ready', this.handleServiceUpdate);
      this.state.isInitialized = true;
    }

    this.state.items = this.listContents ?? [];

    if (this.state.items <= 0) {
      this.handleEmptyResults(true);
      return;
    }

    const payload = this.state.items.reduce((data, current) => {
      const item = {};

      item.cardType = 'PRODUCT';
      item.handle = current?.cprops?.handle;
      item.sku = current.sku;
      item.badgeText = '';
      item.badgeAsset = '';
      item.bundleMessaging = '';
      item.exclusionMessaging = '';

      data.push(item);
      return data;
    }, []);

    this.handleEmptyResults();
    pubSub.publish('swym:results:update', payload);
  }
  handleEmptyResults(isEmpty = false) {
    const banner = this.dom?.banner;
    const grid = this.dom?.grid;

    if (isEmpty) {
      grid.classList.add('hidden');
      banner.classList.add('WishlistResultsBanner--Active');
    } else {
      grid.classList.remove('hidden');
      banner.classList.remove('WishlistResultsBanner--Active');
    }
  }
  connectedCallback() {
    pubSub.subscribe('swym:service:update', this.handleServiceUpdate);
    pubSub.subscribe('swym:service:ready', this.handleServiceUpdate);
  }
  disconnectedCallback() {
    pubSub.unsubscribe('swym:service:update', this.handleServiceUpdate);
    pubSub.unsubscribe('swym:service:ready', this.handleServiceUpdate);
  }
}

customElements.define('wishlist-results', SwymResults);
